var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags && _vm.tags.length)?_c('div',_vm._l((_vm.tags),function(tag,tagIndex){return _c('summary-row',{key:tagIndex,attrs:{"text":tag.name + ' - ' + tag.category,"creation-status":_vm.getCreatedIds[_vm.createdIdsStoreName][tagIndex]}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }